import React from 'react';
import { Grid } from '@material-ui/core';
import CustomLabel from 'src/pages/reportUsage/common/customLabel/CustomLabel.jsx';
import { StyledTextDiv } from '../../../../reportUsage/utils/reportUsage.styled';
import AlertMsg from '../AlertMsg';
import { useTranslation } from 'react-i18next';
  
const TextWithInputs = ({
    xs,
    styleObj,
    value,
    onkeyUp,
    name,
    topLabel,
    bottomLabel,
    width,
    paddingLeft,
    placeholder,
    lg,
    cursor,
    md,
    sm,
    onLabelClick,
    maxLength,
    inputWidth,
    inputHeight,
    inputDisabled,
    inputBorder,
    defaultValue,
    alignText,
    isBundleItem,
    errorMsg,
    fSize,
    autoFocus,
    marginRightQty,
}) => {
    const { t } = useTranslation();
    return (
        <Grid item xs={xs} lg={lg} md={md} sm={sm} style={styleObj}>
            <div
                style={{
                    width: width ? width : '100%',
                    paddingLeft: paddingLeft ? paddingLeft : '0px',
                }}
            >
                {topLabel && (
                    <CustomLabel
                        fSize={'12px!important'}
                        color="#140F4B"
                        opacity="70%"
                        label={topLabel}
                        textAlign={alignText}
                        marginBottom={'8px !important'}
                        marginRightQty={marginRightQty}
                    />
                )}
                {isBundleItem ? (
                    <StyledTextDiv
                        opacity={1}
                        fontFamily="AvenirNextWorld Regular"
                        color="#202124"
                        fontSize={'15px'}
                        padding={'10px 0 0'}
                    >
                        {t('consignmentReturn.common.consignmentBillingHeader.textWithInputs.notApplicable')}
                    </StyledTextDiv>
                ) : (
                    <>
                        <input
                            placeholder={placeholder}
                            disabled={inputDisabled}
                            style={{
                                width: inputWidth ? inputWidth : '100%',
                                height: inputHeight,
                                border: inputBorder
                                    ? inputBorder
                                    : '2px solid #EBEDED',
                                padding: '6px 8px',
                                borderRadius: 6,
                                outline: 'none',
                                background: inputDisabled
                                    ? '#F1F1F1 0% 0% no-repeat padding-box'
                                    : '#FFFFFF 0% 0% no-repeat padding-box',
                                color: '#202124',
                                opacity: inputDisabled ? 0.6 : 1,
                                fontFamily: 'AvenirNextWorld Regular',
                                textAlign: alignText,
                                fontSize: fSize,
                            }}
                            onBlur={!maxLength ? onkeyUp : undefined}
                            name={name}
                            value={value}
                            maxLength={maxLength}
                            onChange={maxLength ? onkeyUp : undefined}
                            defaultValue={defaultValue}
                            autoComplete="off"
                            autoFocus={autoFocus ? 'on' : ''}
                        />
                        {errorMsg && (
                            <div
                                style={{
                                    display: 'flex',
                                    width: 'max-content',
                                    paddingTop: '7px',
                                }}
                            >
                                <AlertMsg message={errorMsg} />
                            </div>
                        )}
                    </>
                )}
                {bottomLabel && (
                    <CustomLabel
                        fSize={'12px!important'}
                        color="#1010EB"
                        cursor={cursor}
                        opacity={1}
                        label={bottomLabel}
                        onLabelClick={onLabelClick}
                        paddingTop={'10px'}
                        letterSpacing={'-0.11px'}
                    />
                )}
            </div>
        </Grid>
    );
};

export default TextWithInputs;
